import {
    Component,
    Injectable,
    OnInit,
    Output,
    EventEmitter,
    Input,
    ViewChild,
} from '@angular/core';
import {
    NgbCalendar,
    NgbDate,
    NgbDatepicker,
    NgbDatepickerI18n,
    NgbDateStruct,
} from '@ng-bootstrap/ng-bootstrap';
import { LanguageService } from '../../../../core/services/language/language.service';

const I18N_VALUES = {
    es: {
        weekdays: ['Lun', 'Mar', 'Mie', 'Jue', 'Vie', 'Sab', 'Dom'],
        months: [
            'Ene',
            'Feb',
            'Mar',
            'Abr',
            'May',
            'Jun',
            'Jul',
            'Ago',
            'Sep',
            'Oct',
            'Nov',
            'Dic',
        ],
    },
    ca: {
        weekdays: ['Dln', 'Dmt', 'Dmc', 'Djs', 'Dvn', 'Dsb', 'Dug'],
        months: [
            'Gen',
            'Feb',
            'Mar',
            'Abr',
            'Mai',
            'Jun',
            'Jul',
            'Ago',
            'Set',
            'Oct',
            'Nov',
            'Des',
        ],
    },
    en: {
        weekdays: ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'],
        months: [
            'Jan',
            'Feb',
            'Mar',
            'Apr',
            'May',
            'Jun',
            'Jul',
            'Aug',
            'Sep',
            'Oct',
            'Nov',
            'Dec',
        ],
    },
    pt: {
        weekdays: ['Seg', 'Ter', 'Qua', 'Qui', 'Sex', 'Sab', 'Dom'],
        months: [
            'Jan',
            'Fev',
            'Mar',
            'Abr',
            'Mai',
            'Jun',
            'Jul',
            'Ago',
            'Set',
            'Out',
            'Nov',
            'Dez',
        ],
    },
    br: {
        weekdays: ['Seg', 'Ter', 'Qua', 'Qui', 'Sex', 'Sab', 'Dom'],
        months: [
            'Jan',
            'Fev',
            'Mar',
            'Abr',
            'Mai',
            'Jun',
            'Jul',
            'Ago',
            'Set',
            'Out',
            'Nov',
            'Dez',
        ],
    },
    it: {
        weekdays: ['Lun', 'Mar', 'Mer', 'Gio', 'Ven', 'Sab', 'Dom'],
        months: [
            'Gen',
            'Feb',
            'Mar',
            'Apr',
            'Mag',
            'Giu',
            'Lug',
            'Ago',
            'Set',
            'Ott',
            'Nov',
            'Dic',
        ],
    },
};

@Injectable()
export class I18n {
    constructor(private languageService: LanguageService) {}
    language = this.languageService.getLocale();
}

@Injectable()
export class CustomDatepickerI18n extends NgbDatepickerI18n {
    private I18NValues: { weekdays: string[]; months: string[] };
    constructor(private _i18n: I18n) {
        super();
        this.setI18NValues();
    }

    setI18NValues() {
        const shortLocale = this._i18n.language.substring(0, 2).toLowerCase();
        if (
            Object.keys(I18N_VALUES).findIndex(
                (lang) => lang === shortLocale
            ) !== -1
        ) {
            this.I18NValues = I18N_VALUES[shortLocale];
        } else {
            this.I18NValues = I18N_VALUES.en;
        }
    }

    getWeekdayLabel(weekday: number): string {
        return this.I18NValues.weekdays[weekday - 1];
    }
    getMonthShortName(month: number): string {
        return this.I18NValues.months[month - 1];
    }
    getMonthFullName(month: number): string {
        return this.getMonthShortName(month);
    }
    getDayAriaLabel(date: NgbDateStruct): string {
        return `${date.day}-${date.month}-${date.year}`;
    }
}

@Component({
    selector: 'app-calendar',
    templateUrl: './calendar.component.html',
    styleUrls: ['./calendar.component.scss'],
    providers: [
        I18n,
        { provide: NgbDatepickerI18n, useClass: CustomDatepickerI18n },
    ],
})
export class CalendarComponent implements OnInit {
    date: NgbDateStruct;
    todayDate;

    @ViewChild(NgbDatepicker)
    datepicker: NgbDatepicker;

    @Input() isDisabled;
    @Output() dateSelectEvent = new EventEmitter<NgbDateStruct>();
    @Output() calendarChangeEvent = new EventEmitter<NgbDateStruct>();

    constructor(private calendar: NgbCalendar) {}

    ngOnInit(): void {
        this.date = this.calendar.getToday();
        this.todayDate = this.calendar.getToday();
    }

    onNavigate(event) {
        if (event.current === null) {
            return;
        }
        const selected = {
            year: event.next.year,
            month: event.next.month,
            day: 1,
        };
        this.onCalendarChange(selected);
    }

    onDateSelect(date: NgbDateStruct) {
        this.dateSelectEvent.emit(date);
    }

    onCalendarChange(date: NgbDateStruct) {
        this.calendarChangeEvent.emit(date);
    }

    resetCalendar() {
        this.date = this.calendar.getToday();
        this.datepicker.navigateTo(this.date);
        this.isDisabled = null;
    }
}
